/**
 * device service
 */

import Resource from './resource'

export default new Resource('device')



// WEBPACK FOOTER //
// ./src/libraries/services/device.js